import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { BarRightIcon } from '@ui/icons/BarRight.icon'
import { CalendarIcon } from '@ui/icons/Calendar.icon'
import { CalendarEventIcon } from '@ui/icons/CalendarEvent.icon'
import { ChartBarIcon } from '@ui/icons/ChartBar.icon'
import { ChartPieSliceIcon } from '@ui/icons/ChartPieSlice.icon'

import { TickmillProductType } from '@model/TickmillProductType'

import { MenuSection, useWithMobileIcon } from '../useMenuSections'

export const useMarketDataMenu = (): MenuSection => {
  const { t } = useTranslation()
  const withMobileIcon = useWithMobileIcon()

  return useMemo(
    () => ({
      id: 'market-data-menu',
      label: t('Tabs.Market Data'),
      icon: ChartBarIcon,
      products: [TickmillProductType.CFD, TickmillProductType.ETD],
      children: [
        {
          id: 'earnings-calendar',
          label: t('Earnings Calendar'),
          path: '/dashboard/tools/earnings-calendar',
          products: [TickmillProductType.CFD],
          icon: withMobileIcon(CalendarIcon),
        },
        {
          id: 'economic-calendar',
          label: t('Economic Calendar'),
          path: '/dashboard/tools/economic-calendar',
          products: [TickmillProductType.CFD],
          icon: withMobileIcon(CalendarEventIcon),
        },
        {
          id: 'research-terminal',
          label: t('Research Terminal'),
          path: '/dashboard/tools/research-terminal',
          products: [TickmillProductType.CFD],
          icon: withMobileIcon(BarRightIcon),
        },
        {
          id: 'stock-dividends',
          label: t('Tabs.Stock Dividends'),
          path: '/dashboard/traders-room/stock-dividends',
          products: [TickmillProductType.CFD],
          icon: withMobileIcon(ChartPieSliceIcon),
        },
      ],
    }),
    [t, withMobileIcon]
  )
}
